import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase, Typography } from '@material-ui/core';
import _ from 'lodash';
import NotFound from "assets/images/not_found.png";
import clsx from 'clsx';
import CriminalImage from 'assets/images/map_icons/criminal.png';
import FunkyImage from 'assets/images/map_icons/funky.png';


const useStyles = makeStyles(theme => ({
  image: {
    position: 'relative',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&$disabled': {
      '& $imageBackdrop': {
        opacity: 0.7
      }
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.05,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.25,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    //padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  disabled:{}
}));

interface Props{
  image: string;
  title: string;
  subtitle?: string;
  onClick(): void;
  disabled?: boolean;
  isPvPZone?: boolean;
  width?: string;
  height?: string;
  hideLabel?: boolean;
  style?: React.CSSProperties;
  borderRadius?: string;
  textStyle?: React.CSSProperties;
  backdropStyle?: React.CSSProperties;
  subtitleStyle?: React.CSSProperties;
  textContainerStyle?: React.CSSProperties;
  isCriminal?: boolean;
  isFunky?: boolean;
}


const ZoneButton: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <ButtonBase
      focusRipple
      key={props.title}
      className={clsx(classes.image,{
        [classes.disabled]: props.disabled
      })}
      focusVisibleClassName={classes.focusVisible}
      style={{
        ...props.style,
        width: props.width ? props.width : '170px',
        height: props.height ? props.height : '170px',
        borderRadius: props.borderRadius ? props.borderRadius : '0px'
      }}
      onClick={props.onClick}
      disabled={props.disabled}
      title={props.title}
    >
      {props.isCriminal && <img src={CriminalImage} style={{width:'40px',zIndex:1,position:'absolute',top:'5px',left:'5px'}} />}
      {props.isFunky && <img src={FunkyImage} style={{width:'40px',zIndex:1,position:'absolute',top:'5px',right:'5px'}} />}
      <span
        className={classes.imageSrc}
        style={{
          backgroundImage: `url(${props.image}), url(${NotFound})`,
          borderRadius: props.borderRadius ? props.borderRadius : '0px'
        }}
      />
      <span className={classes.imageBackdrop} style={{
        ...props.backdropStyle,
        borderRadius: props.borderRadius ? props.borderRadius : '0px'
      }} />
      {!props.hideLabel &&
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
            style={{
              color: props.isPvPZone ? '#c8dc24' : 'white',
              fontWeight: props.isPvPZone ? 'bold' : 'inherit',
              ...props.textContainerStyle
            }}
          >
            <span style={{...props.textStyle}}>
              {props.title}
            </span>
            {props.subtitle &&
              <div style={{...props.subtitleStyle}}>
                {props.subtitle}
              </div>
            }
            <span className={classes.imageMarked} style={{backgroundColor: props.isPvPZone ? '#c8dc24' : 'white'}} />
          </Typography>
        </span>
      }
      
    </ButtonBase>
    
  )
}

export default ZoneButton;